import React, { useEffect, useState } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import Header from "../../sharedScreens/Header";
import RoomDetailCard from "../../components/composite/hotelRoomDetailcard/RoomDetailCard";
import RoomPriceDetailCard from "../../components/composite/hotelRoomDetailcard/RoomPriceDetailCard";
import GuestDetailsCard from "../../components/composite/hotelRoomDetailcard/GuestDetailsCard";
import FlightPromoCard from "../../components/composite/flightDetailsCard/FlightPromoCard";
import { PaymentModeCard } from "../../components/composite/PaymentModeCard";
import { HotelServices } from "../../services/hotelSearch/HotelSearchService";
import { UtilService } from "../../services/shared/UtilService";
import { useGlobalState } from "../../services/context/AuthContext";
import { PGRes } from "@/constants/types";
import { generateRandomInteger } from "../../constants/helper";
import EditIcon from "@mui/icons-material/Edit";
import { Checkbox } from "@mui/material";
import { msgTypes } from "../../constants/msgTypes";

const HotelRoomDetail: React.FC = () => {
  const navigate = useNavigate();
  const [isCheckBoxChecked, setIsCheckBoxChecked] = useState<boolean>(false);
  const location = useLocation();
  const payload = location.state?.payload;

  const room = payload?.Guests?.Room;
  const roomCount = payload?.Guests?.Count || 1;
  const { userInfo, setUserInfo } = useGlobalState();
  const [showPaymentSection, setShowPaymentSection] = useState(false);
  const [guestInfo, setGuestInfo] = useState<any | null>(null);
  const hotel = payload || {}; // hotel and room data
  const guestData = guestInfo?.guestData || [];
  const contact = guestInfo?.contact || {};
  const gst = guestInfo?.gst;
  const checkIn = new Date(hotel?.CheckInDate);
  const checkOut = new Date(hotel?.CheckOutDate);
  const timeDiff = checkOut.getTime() - checkIn.getTime();
  const nights =
    Math.ceil(
      (new Date(payload?.CheckOutDate).getTime() -
        new Date(payload?.CheckInDate).getTime()) /
        (1000 * 60 * 60 * 24)
    ) || 1;
  const [ewtsOffer, setEwtsOffer] = useState(0);
  const [appliedCouponCode, setAppliedCouponCode] = useState("");

  const handleCouponApply = (amount: number, code: string) => {
    setEwtsOffer(amount);
    setAppliedCouponCode(code);
  };
  const priceInfo = {
    Price: payload?.Price || 0,
    disc: payload?.disc || 0,
    ewtsoffer: ewtsOffer,
    surchargeTotal: payload?.surchargeTotal || 0,
    TotalPrice:
      (payload?.Price || 0) -
      (payload?.disc || 0) -
      ewtsOffer +
      (payload?.surchargeTotal || 0),
  };

  const handleContinue = (info: any) => {
    setGuestInfo(info);
    setShowPaymentSection(true);
  };
  const guestRooms = payload?.Guests?.Room || payload?.Rooms?.Room || [];

  const adultCount = guestRooms.reduce(
    (sum: number, r: any) => sum + (r?.NumberOfAdults || 0),
    0
  );

  const childCount = guestRooms.reduce(
    (sum: number, r: any) => sum + (r?.Child?.NumberOfChild || 0),
    0
  );
  const createBooking = async () => {
    try {
      const numberOfRooms = hotel?.Guests?.Count || 1;
      const guestsPerRoom = Math.ceil(guestData.length / numberOfRooms);

      const distributedRooms = Array.from(
        { length: numberOfRooms },
        (_, index) => {
          const start = index * guestsPerRoom;
          const end = start + guestsPerRoom;
          const guestsForThisRoom = guestData.slice(start, end);

          return {
            AdultDetails: guestsForThisRoom.map((guest: any) => ({
              Age: guest?.Age || 30,
              firstName: guest?.firstName || "Guest",
              lastName: guest?.lastName || "User",
              mobile: guest?.mobile || "",
              PaxType: guest?.PaxType || "0",
              Prefix: guest?.title || "Mr",
            })),
            ChildDetails: guestData?.flatMap(
              (i: any) =>
                i?.children?.map((j: any) => ({
                  firstName: j?.firstName || "",
                  lastName: j?.lastName || "",
                  Prefix: j?.title || "",
                })) || []
            ),
            rateCode: hotel?.rateCode || hotel?.RateKey || "",
            rateKey: hotel?.RateKey || "",
            roomType: hotel?.RoomType || "",
            roomTypeCode: hotel?.RoomTypeCode || "",
            smokingPreference: null,
          };
        }
      );

      const bookingPayload = {
        AddressDetail: {
          address: hotel?.HotelAddress || "",
          city: hotel?.hotelCity || "Delhi",
          countryCode: "IN",
        },

        BookingID: null,
        CancellationPolicy: hotel?.CancellationPolicy || "",
        chargeableRate: priceInfo.TotalPrice,
        totalAmount: priceInfo.TotalPrice,
        checkInDate: hotel?.CheckInDate,
        checkOutDate: hotel?.CheckOutDate,
        checkInTime: hotel?.CheckInTime || "12:00 PM",
        checkOutTime: hotel?.CheckOutTime || "11:00 AM",
        City: hotel?.hotelCity || null,
        Country: hotel?.hotelCountry || null,
        adultCount,
        childCount,
        CurrencyCode: hotel?.currencyCode || "INR",
        EMTCommonID:"EMTHOTEL-4521578" ,
        EngineID: hotel?.Engine || "22",
        HotelChain: null,
        hotelID: hotel?.HotelID || "",
        HotelReservationInfo: {
          BankCountryCode: null,
          BankName: null,
          Email: contact?.email || "",
          ExpirationYear: null,
          Title: guestData?.[0]?.title || "Mr",
          cardNumber: null,
          cardType: null,
          creditCardIdentifier: null,
          expirationMonth: null,
          firstName: guestData?.[0]?.firstName || "Guest",
          lastName: guestData?.[0]?.lastName || "User",
          mobile: contact?.mobile || "",
        },
        taxRate: hotel?.taxRate || 0,
        price: priceInfo.Price,
        disc: priceInfo.disc + priceInfo.ewtsoffer,
        Meal: hotel?.Meal || "Room_Only",
        MealType: hotel?.MealType || "Room_Only",
        Name: hotel?.HotelName || "Unknown Hotel",
        Nationality: "IN",
        rateCode: hotel?.rateCode || hotel?.RateKey || "",
        rateKey: hotel?.RateKey || "",
        roomRateDescription: hotel?.roomRateDescription || "",
        Rooms: {
          Count: numberOfRooms,
          Room: distributedRooms,
        },
        roomType: hotel?.RoomType || "",
        roomTypeCode: hotel?.RoomTypeCode || "",
        Tax: "0",
        Transactionid: 11411206,
        TransactionIdentifier: "",
        TransactionRefNo: "EMT123_TEST",
        UniqueID: null,
      };

      const response = await HotelServices.getHotelBooking(bookingPayload);

      const { ...payloadWithoutAuth } = bookingPayload;

      const res = {
        ...response?.data,
        booking_req: payloadWithoutAuth,
        booking_res: response?.data,
      };

      return res;
    } catch (error) {
      console.error("❌ Booking failed:", error);
      alert("Booking failed. Please try again.");
    }
  };
  const fetchBalance = async () => {
    try {
      const response = await UtilService.fetchBalance();
      if (response?.statusMsg === msgTypes?.SUCCESS?.msg) {
        // Assuming the response contains the balance data
        setUserInfo({
          ...userInfo,
          postpaidBalance: response.data?.postpaid || 0,
          prepaidBalance: response.data?.prepaid || 0,
        });
      } else {
        console.error("Failed to fetch balance data");
      }
    } catch (error) {}
  };

  const saveBookingDetail = async (
    id: string,
    bookingType: string,
    paymentType: string,
    pgRes?: PGRes | null,
    bookingRes?: any | null
  ) => {
    try {
      const hotelPaymentPayload = {
        booking_txn_id: id, // you can generate new UUID
        booking_type: bookingType,
        payment_type: paymentType,
        couponCode: appliedCouponCode,
        discount_amount: ewtsOffer,
        amount: bookingRes?.booking_req?.chargeableRate || 0,
        ag_id: pgRes?.ag_id,
        ag_ref: pgRes?.ag_ref,
        country: pgRes?.country,
        currency: pgRes?.currency,
        me_id: pgRes?.me_id,
        order_number: pgRes?.order_number,
        status: pgRes?.status,
        transaction_date: pgRes?.transaction_date,
        transaction_time: pgRes?.transaction_time,
        booking_req: {
          ...bookingRes?.booking_req,
          Transactionid: 11411206 + generateRandomInteger(),
        },
        booking_res: bookingRes?.booking_res,
      };

      const response = await UtilService.captureTransaction(
        hotelPaymentPayload
      );

      if (!!response) {
        fetchBalance();

        navigate("/hotelbookingconfirmation", {
          state: {
            id: id,
            bookingRes: bookingRes,
          },
        }); // ✅ Replace with your actual route

        return true;
      }
    } catch (error) {
      return false;
    }
  };
  const hotelInfo = {
    guestInfo,
    room,
  };
  const TermsAndCondition = () => (
    <div className="d-flex align-items-center">
      <Checkbox
        checked={isCheckBoxChecked} // ✅ use `checked`, not `value`
        onChange={(e) => setIsCheckBoxChecked(e.target.checked)} // ✅ proper change handling
      />
      <span className="pt-md-3">
        I understand & agree to the{" "}
        <span className="showmore">Terms and Conditions</span>.
      </span>
    </div>
  );
  return (
    <div className="grow">
      <div className="wrapper flex grow flex-col">
        <Header />
      </div>
      <main className="grow content" id="content" role="content">
        <div className="container-fluid">
          <div className="row">
            {/* Left Column */}
            <div className="col-lg-9 col-sm-12">
              <RoomDetailCard room={payload} />

              {/* Toggle between guest form and summary */}
              {/* Guest Details or Payment View */}
              {!showPaymentSection ? (
                <GuestDetailsCard
                  room={room}
                  roomCount={roomCount}
                  initialData={guestInfo} // ✅ prefill on edit
                  onContinue={(info) => {
                    setGuestInfo(info);
                    setShowPaymentSection(true);
                  }}
                />
              ) : (
                <>
                  <div className="card mb-3">
                    <div className="card-header card-head-bg d-flex justify-content-between align-items-center">
                      <p className="passenger-title mb-0">
                        <i className="fas fa-user passenger-icon pe-2" />
                        Guest Information
                      </p>
                      <div
                        className="cursor-pointer"
                        onClick={() => setShowPaymentSection(false)} // ✅ switch back to edit
                      >
                        <EditIcon />
                      </div>
                    </div>
                    <div className="card-body">
                      {guestInfo?.guestData?.map(
                        (guest: any, index: number) => (
                          <>
                            <div
                              className="align-items-center flex-wrap"
                              key={index}
                            >
                              <div className="d-flex align-items-center">
                                <div>
                                  <span className="fw-bold">
                                    Guest {index + 1}: &nbsp; &nbsp;
                                  </span>{" "}
                                </div>

                                <div className="mr-5">
                                  <span className="d-flex align-items-center">
                                    <h6 className="fw-bold">
                                      Title:&nbsp; &nbsp;
                                    </h6>
                                    <span>{guest?.title}</span>
                                  </span>
                                  <span className="d-flex align-items-center">
                                    <h6 className="fw-bold">
                                      Name:&nbsp; &nbsp;
                                    </h6>
                                    <span>
                                      {guest?.firstName} {guest?.lastName}
                                    </span>
                                  </span>
                                </div>
                                <hr className="my-4"></hr>
                              </div>

                              {/* Children data */}
                              {guest?.children?.length > 0 && (
                                <div className="mt-1 d-flex align-items-center">
                                  {guest.children.map(
                                    (child: any, childIndex: number) => (
                                      <div
                                        className="d-flex align-items-center"
                                        key={childIndex}
                                      >
                                        <div>
                                          <span className="fw-bold">
                                            Child {childIndex + 1}: &nbsp;
                                            &nbsp;
                                          </span>{" "}
                                        </div>
                                        <div className="mr-5 ">
                                          <span className="d-flex align-items-center">
                                            <h6 className="fw-bold">
                                              Title:&nbsp; &nbsp;
                                            </h6>
                                            {child?.title}
                                          </span>
                                          <span className="d-flex align-items-center">
                                            <h6 className="fw-bold">
                                              Name:&nbsp; &nbsp;
                                            </h6>
                                            {child?.firstName} {child?.lastName}
                                          </span>
                                        </div>
                                      </div>
                                    )
                                  )}
                                </div>
                              )}
                            </div>
                            <hr className="my-4"></hr>
                          </>
                        )
                      )}

                      {/* <hr className="my-3" /> */}
                      <div className="row">
                        <div className="col-lg-3 col-sm-6 col-6">
                          <p className="fw-bold">Email</p>
                          <p>{guestInfo?.contact?.email}</p>
                        </div>
                        <div className="col-md-3 col-sm-6 col-6">
                          <p className="fw-bold">Passport</p>
                          <p>{guestInfo?.contact?.passport}</p>
                        </div>
                        <div className="col-lg-3 col-sm-6 col-6">
                          <p className="fw-bold">Mobile No.</p>
                          <p>{guestInfo?.contact?.mobile}</p>
                        </div>
                        <div className="col-lg-3 col-sm-6 col-6">
                          <p className="fw-bold">Room</p>
                          <p>{payload?.Guests?.Count || 1}</p>
                        </div>
                      </div>
                    </div>
                    {/* <hr className="my-3" /> */}
                    {gst && (
                      <div className="card mt-3">
                        <div className="card-header bg-light fw-bold">
                          GST Information
                        </div>
                        <div className="card-body">
                          <div className="row mb-2">
                            <div className="col-md-3 col-6">
                              <p className="fw-bold mb-1">GST No</p>
                              <p>{gst.gstNo || "-"}</p>
                            </div>
                            <div className="col-md-3 col-6">
                              <p className="fw-bold mb-1">Company Name</p>
                              <p>{gst.companyName || "-"}</p>
                            </div>
                            <div className="col-md-3 col-6">
                              <p className="fw-bold mb-1">GST Email</p>
                              <p>{gst.gstEmail || "-"}</p>
                            </div>

                            <div className="col-md-3 col-6">
                              <p className="fw-bold mb-1">GST Mobile</p>
                              <p>{gst.gstMobile || "-"}</p>
                            </div>
                            <div className="col-md-3 col-6">
                              <p className="fw-bold mb-1">GST Address</p>
                              <p>{gst.address || "-"}</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </>
              )}
            </div>

            {/* Right Column */}
            <div className="col-lg-3 col-sm-12">
              <div className="sticky-sidebar">
                <RoomPriceDetailCard
                  priceInfo={priceInfo}
                  roomCount={roomCount}
                  nights={nights}
                />

                {showPaymentSection ? (
                  <PaymentModeCard
                    activeStep={2}
                    createBooking={createBooking}
                    grandTotal={priceInfo.TotalPrice}
                    bookingFor="hotel"
                    saveFlightBookingDetails={saveBookingDetail}
                    couponCode={appliedCouponCode}
                    termsAndCondition={<TermsAndCondition />}
                    isCheckBoxChecked={isCheckBoxChecked}
                    hotelInfo={hotelInfo} //TODO:Prepare data
                  />
                ) : (
                  <FlightPromoCard
                    basePrice={payload?.Price || 0}
                    onApplyCoupon={handleCouponApply}
                    initialCouponCode={appliedCouponCode}
                    initialDiscount={ewtsOffer}
                  />
                )}
              </div>
            </div>

            {/* <div className="col-md-12">
              jyhgkjhg
            </div> */}
          </div>
        </div>
      </main>
    </div>
  );
};

export default HotelRoomDetail;
